import { ref } from 'vue';

// Module-level ref so any component that calls this composable sees the same
// reactive state — both the preview display and the upload action stay in sync
// without prop drilling or events.
const transferPreview = ref<string | undefined>(undefined);

export function useTransferPreview() {
    return { transferPreview };
}
